import type { Item } from "../api";

type SimilarityField = {
    key: keyof Item;
    blankable: boolean;
    normalize: (value: unknown) => string;
};

const SIMILARITY_FIELDS: SimilarityField[] = [
    {
        key: "name",
        blankable: false,
        normalize: (v) => String(v ?? "").trim().toLowerCase(),
    },
    {
        key: "brand",
        blankable: true,
        normalize: (v) => String(v ?? "").trim().toLowerCase(),
    },
    {
        key: "category",
        blankable: true,
        normalize: (v) => String(v ?? "").trim().toLowerCase(),
    },
    {
        key: "barcode",
        blankable: true,
        normalize: (v) => String(v ?? "").trim().toLowerCase(),
    },
    {
        key: "location_id",
        blankable: true,
        normalize: (v) => (typeof v === "number" && v > 0 ? String(v) : ""),
    },
    {
        key: "expiry_date",
        blankable: true,
        normalize: (v) => String(v ?? "").trim(),
    },
    {
        key: "notes",
        blankable: true,
        normalize: (v) => String(v ?? "").trim().toLowerCase(),
    },
    {
        key: "image_path",
        blankable: true,
        normalize: (v) => (v ? "has" : ""),
    },
];

export function isSimilarItem(candidate: Partial<Item>, existing: Item): boolean {
    for (const field of SIMILARITY_FIELDS) {
        const a = field.normalize(candidate[field.key]);
        const b = field.normalize(existing[field.key]);
        if (a === b) continue;
        if (field.blankable && (a === "" || b === "")) continue;
        return false;
    }
    return true;
}

export function findSimilarItems(
    candidate: Partial<Item>,
    existingItems: Item[],
    excludeId?: number,
): Item[] {
    return existingItems.filter(
        (existing) => existing.id !== excludeId && isSimilarItem(candidate, existing),
    );
}
